import InView from 'inview';
import { CountUp } from 'countup.js/dist/countUp.umd';

export class CtaBarStat {
	isCounting = false;

	hasAnimated = false;

	constructor(el) {
		if (!el) return;

		this.el = el;
		this.number = this.parseNumber();
		this.initializeCountUp();
		this.setupInViewObserver();

		// Trigger immediately in editor context
		if (this.isInEditor()) {
			setTimeout(() => this.triggerAnimations(), 300);
		}
	}

	isInEditor() {
		return document.body.classList.contains('wp-admin') || document.body.classList.contains('block-editor-page');
	}

	parseNumber() {
		return parseFloat(this.el.dataset.number);
	}

	initializeCountUp() {
		const decimalPlaces = String(this.number).includes('.')
			? String(this.number).split('.')[1].length
			: 0;

		this.countUpOptions = {
			decimalPlaces,
			suffix: '%',
			duration: 1.5,
			startVal: 0,
		};

		try {
			this.countUp = new CountUp(this.el, this.number, this.countUpOptions);
			if (this.countUp.error) throw this.countUp.error;
		} catch (e) {
			console.error('CountUp initialization failed:', e);
			this.countUp = null;
		}
	}

	setupInViewObserver() {
		if (this.isInEditor()) return;

		this.inView = InView(this.el, (isInView) => {
			if (isInView) this.triggerAnimations();
		}, {
			offset: 100,
			defer: false,
		});
	}

	triggerAnimations() {
		if (this.hasAnimated) return;
		this.hasAnimated = true;

		// Start count animation
		if (this.countUp) {
			this.countUp.start();
		} else {
			this.el.textContent = this.number + (this.countUpOptions.suffix || '');
		}
	}

	destroy() {
		if (this.inView) this.inView.destroy();
	}
}

export function initCtaBarStats() {
	// Clean up previous instances
	if (window.embarkCtaBarStats) {
		window.embarkCtaBarStats.forEach((stat) => stat.destroy());
	}

	const statEls = [...document.querySelectorAll('.cta-bar-stat__number.js-counter')];
	if (!statEls.length) return;

	window.embarkCtaBarStats = statEls.map((el) => new CtaBarStat(el));

	// Gutenberg editor compatibility
	if (typeof wp !== 'undefined' && wp.data) {
		wp.data.subscribe(() => {
			setTimeout(initCtaBarStats, 100);
		});
	}
}

// Initialize with multiple fallbacks
const init = () => {
	if (
		document.readyState === 'complete'
        || document.readyState === 'interactive'
	) {
		setTimeout(initCtaBarStats, 100);
	} else {
		document.addEventListener('DOMContentLoaded', initCtaBarStats);
	}
};

init();
